import { dataShieldWave } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldWave = /*#__PURE__*/createIcon(dataShieldWave)
export default IconShieldWave
